import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-publish",
  "use": "icon-publish-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-publish\"><defs><style type=\"text/css\"></style></defs><path d=\"M989 1006H35c-17.673 0-32-14.327-32-32s14.327-32 32-32h954c17.673 0 32 14.327 32 32s-14.327 32-32 32zM19 948l73-212 205 213z m131-283l202 209 444-443-204-205z m509-517l202 202 58-60s22-32 15-57S801 97 787 83s-41-12-71 13-57 52-57 52z\" p-id=\"29194\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"}!./src/assets/icons/svg/publish.svg
// module id = yypv
// module chunks = 1